<template>
  <div class="page-header">
    <b-container>
      <b-row align-v="center" align-h="between">
        <b-col cols="12" lg="auto">
          <slot />
        </b-col>
        <b-col v-if="breadcrumbs" cols="12" lg="auto">
          <breadcrumb :items="breadcrumbs" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import Breadcrumb from '../Breadcrumb/Breadcrumb'

  export default {
    components: { Breadcrumb },
    props: {
      breadcrumbs: {
        type: Array,
        default: () => [],
      },
    },
  }
</script>

<style lang="scss" src="./PageHeader.scss"></style>
